<template>
    <div class="container-master">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
}
</script>



// WEBPACK FOOTER //
// App.vue?73e531f6